import { combineReducers } from 'redux';
import announcements from './announceReducer'
import maps from './mapReducer'
import isFontSizeEnabled from './fontSizeReducer'
import isColourBlindEnabled from './colourBlindReducer'
import language from './languageReducer'

export default combineReducers({
    announcements: announcements,
    maps: maps,
    isColourBlindEnabled: isColourBlindEnabled,
    isFontSizeEnabled: isFontSizeEnabled,
    language: language

});